import { css } from 'linaria';

export const catalogCardContent = css`
  display: flex;
  height: 100%;

  > div {
    justify-content: flex-end;
  }
`;

export const catalogCardContentImagePreviewContainer = css`
  display: flex;
  align-items: flex-end;
  column-gap: 8px;
  padding: 16px;
`;

export const catalogCardContentActiveImage = css`
  && {
    border: 2px solid var(--control-primary);
  }
`;

export const catalogCardContentImagePreviewWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: var(--rounding-m);
  border: 1px solid var(--control-secondary);
  cursor: pointer;
`;

export const catalogCardContentImagePreviewRest = css`
  border-radius: var(--rounding-m);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-secondary);
  cursor: pointer;
  border: none;
`;

export const catalogCardContentImagePreview = css`
  width: 40px;
  height: 40px;
`;

export const galleryTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const catalogLink = css`
  height: 100%;
`;

export const catalogImageWrapper = css`
  width: 100%;
  height: 309px;

  @media (--to-desktop) {
    height: 200px;
  }
`;

export const catalogImage = css`
  && {
    width: 100%;
    height: 342px;
    border-radius: var(--rounding-l) var(--rounding-l) 0 0;
    object-fit: cover;

    @media (--only-desktop) {
      height: 271px;
    }

    @media (--only-tablet) {
      height: 190px;
    }

    @media (--only-mobile) {
      height: 202px;
    }
  }
`;

export const catalogFirstImage = css`
  && {
    width: 100%;
    height: 632px;

    @media (--only-desktop) {
      height: 502px;
    }

    @media (--only-tablet) {
      height: 352px;
    }

    @media (--only-mobile) {
      height: 202px;
    }
  }
`;
